import "./MultiAccountEquityOrderSummaryComponent.scss";
import template from "./MultiAccountEquityOrderSummaryComponent.html";
import {IComponentOptions} from "angular";
import {OrderVettingResponse} from "../../../types/OrderVettingResponse";
import {EquityWizardData} from "../../../place-equity-order-wizard/models/EquityWizardData";
import {PlaceOrderRequest} from "../../../services/models/PlaceOrderRequest";

export const MultiAccountEquityOrderSummary = "tfMultiAccountEquityOrderSummary";

export interface SingleAccountSummary {
    accountNumber: string | null;
    accountName: string | null;
    totalFees: number | null;
    placeOrderRequest: PlaceOrderRequest;
    currentBalance: number | null;
    costOfTrade: number | null;
    totalCost: number | null;
    cashAfterTrade: number | null;
}

export function multiAccountEquityOrderSummary(): IComponentOptions {
    return {
        template,
        bindings: {
            orders: "<",
            response: "<"
        },
        controllerAs: "ctrl",
        controller: EquityOrderSummaryComponentController
    };
}

export class EquityOrderSummaryComponentController {
    /** @input */
    public readonly response: OrderVettingResponse[] | null;
    public readonly orders: EquityWizardData[];
    public readonly displayData: SingleAccountSummary[] | undefined ;

    constructor() {
        this.displayData = this.getDisplayData();
    }

    public getDisplayData(): SingleAccountSummary[] |undefined {
        return this.response?.map( v => {
            const  currentBalance = this.getCurrentBalance(v);
            const costOfTrade = this.getCostOfTrade(v);
            const totalFees = this.getTotalFees(v);
            const totalCost = this.getTotalCost(costOfTrade, totalFees);
            const cashAfterTrade = this.getCashAfterTrade(currentBalance, totalCost);

            return {
                accountName: v.accountName,
                accountNumber: v.accountNumber,
                placeOrderRequest: v.placeOrderRequest,
                currentBalance,
                costOfTrade,
                totalFees,
                totalCost,
                cashAfterTrade
            };
        });
    }

    public getCurrentBalance(response: OrderVettingResponse): number | null {
        if (response == null) {
            return null;
        } else {
            return response.scenarioSummary.currentBalance;
        }
    }

    public getCostOfTrade(response: OrderVettingResponse): number | null {
        if (response == null) {
            return null;
        } else {
            return response.scenarioSummary.totalCost;
        }
    }

    public getTotalFees(response: OrderVettingResponse): number | null {
        if (response == null) {
            return null;
        } else {
            return Object.values(response.scenarioSummary.fees)
                         .reduce((acc, next) => acc + next, 0);
        }
    }

    public getTotalCost(tradeCost: number | null, fees: number | null): number | null {
        if ((tradeCost == null) || (fees == null)) {
            return null;
        } else {
            return tradeCost - fees;
        }
    }

    public getCashAfterTrade(before: number | null, cost: number | null): number | null {
        if ((before == null) || (cost == null)) {
            return null;
        } else {
            return before + cost;
        }
    }

}
